import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  /* background: #fff;  Is this necessary? */
  font-size: 20px;
  padding-top: 90px;
`;

const Inner = styled.div`
  align-items: center;
  color: #252423;
  display: flex;
  flex-direction: row-reverse;
  font-size: 20px;
  margin: 0 auto;
  max-width: 1400px;
  padding: 0 4vw;
  min-height: 900px;
  min-height: 20vh;

  img {
    width: 650px;
    filter: saturate(0) brightness(1.1);
    mix-blend-mode: multiply;
    -o-object-fit: cover;
    object-fit: cover;
    max-width: 100vw;
    transform: translate(-20px, -15px);
  }

  @media (max-width: 1200px) {
    img {
    }
  }
  @media (max-width: 800px) {
    flex-direction: column-reverse;

    img {
      width: 90%;
    }
  }
`;

const ImgWrapper = styled.div`
  background: var(--nude-200);
  transform: translateX(-20%);
  width: 60%;

  img {
    max-width: 100%;
    aspect-ratio: 1;
  }

  @media (max-width: 1200px) {
    transform: translateX(-5%);
  }

  @media (max-width: 800px) {
    transform: translateY(-10px);
  }
`;

const ValueProp = styled.div`
  padding: 190px 0;
  text-align: left;
  margin: 0 auto;
  width: 40%;

  @media (max-width: 1200px) {
    width: 100%;
    max-width: none;
  }
  @media (max-width: 800px) {
    width: auto;
    text-align: center;
    padding: 60px 20px 20px;
    padding-top: 10px;
  }
  @media (max-width: 400px) {
  }
`;

const Title = styled.h1`
  font-family: 'primarytypeface', 'secondarytypeface', serif;
  font-size: 65px;
  color: inherit;
  font-weight: 400;
  line-height: 1.2;
  margin: 0 auto 20px;

  @media (max-width: 800px) {
    font-size: 54px;
  }

  @media (max-width: 400px) {
    font-size: 48px;
  }
`;

const Subtitle = styled.h2`
  font-family: 'bodytypeface', sans-serif;
  max-width: 750px;
  margin: 0 0 20px;
  font-size: 30px;
  color: #444;
  font-weight: 400;

  @media (max-width: 800px) {
    font-size: 24px;
  }

  em {
    font-style: normal;
    text-decoration: underline;
  }
`;

const CTAWrapper = styled.div`
  margin: 20px 10px 20px 0;
  display: flex;

  > * {
    margin: 10px 20px 10px 0;
  }

  @media (max-width: 800px) {
    display: block;
    width: 100%;

    > * {
      margin: 10px;
    }
  }
`;

const PreTitle = styled.div``;

const MarketingHero = ({
  pretitle = null,
  title = 'Your Wedding Journey Starts Here',
  subtitle = 'Plan, organise and conquer your wedding goals, with everything you need.',
  heroImg = '',
  imgAlt = '',
  component = null,
  CTA = null,
}) => {
  return (
    <Wrapper>
      <Inner>
        <ValueProp>
          {pretitle && <PreTitle>{pretitle}</PreTitle>}
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          {!!CTA && <CTAWrapper>{CTA}</CTAWrapper>}
        </ValueProp>
        {heroImg && (
          <ImgWrapper>
            <img src={heroImg} alt={imgAlt} />
          </ImgWrapper>
        )}
        {component}
      </Inner>
    </Wrapper>
  );
};

export default MarketingHero;
